export default {
  'accountSummaryWidget.allAccountsText': 'All Accounts',
  'accountSummaryWidget.reportingText': 'Custom Reporting',
  'accountSummaryWidget.accountActivityText': 'Account Activity',
  'accountSummaryWidget.financialOverviewText': 'Financial Overview',
  'accountSummaryWidget.incomingWireDetailText': 'Incoming Wire Detail',
  'accountSummaryWidget.wireDetailText': 'Wire Detail',
  'accountSummaryWidget.COMMON.ACCESS_NOT_PERMITTED': 'User is not entitled to any accounts',
  'accountSummaryWidget.dateAndTime': 'Date and Time',
  'accountSummaryWidget.receivingAccount': 'Receiving Account',
  'accountSummaryWidget.amount': 'Amount',
  'accountSummaryWidget.bankReference': 'Bank Reference',
  'accountSummaryWidget.customerReference': 'Customer Reference',
  'accountSummaryWidget.wireDetail': 'Wire Detail'
};
